import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Tooltip as HeadlessTooltip } from '@flywire/react-headlessui';
import { cx } from '../../utils/cx';
import { Content } from './Content';
import { Trigger } from './Trigger';
export const useTooltipClasses = ({ className }) => {
    return cx('group/Tooltip relative inline-block', className);
};
const TooltipComponent = forwardRef(({ className, ...rest }, ref) => {
    const classes = useTooltipClasses({ className });
    return _jsx(HeadlessTooltip, { ref: ref, className: classes, ...rest });
});
TooltipComponent.displayName = 'Tooltip';
const Tooltip = TooltipComponent;
Tooltip.Content = Content;
Tooltip.Trigger = Trigger;
export { Tooltip };
//# sourceMappingURL=Tooltip.js.map